import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Popconfirm, Typography, notification, Space, Layout } from 'antd';

import CustomButton from '../../components/CustomButton';
import INTERNAL_LINKS from '../../enums/InternalLinks';
import MESSAGES from '../../enums/Messages';
import BreadcrumbContainer from '../../containers/Breadcrumb';

import {
  ajaxTable as filterAnnouncements,
  terminateAnnouncement,
} from '../../api/module/announcement';

import './style.scss';
import AjaxTable from '../../components/AjaxTable';
import { catchExceptionSRate } from '../../utils/helpers/helpers';
import { CustomTooltip, IconButton } from '../../components';
import { CloseCircleFilled, EditFilled, TagsFilled } from '@ant-design/icons';

const { Title } = Typography;
const { Content } = Layout;

const breadcrumbItems = [
  {
    text: 'Convocatoria',
    to: `${INTERNAL_LINKS.ANNOUNCEMENT}`,
  },
  {
    text: 'Convocatorias en curso',
  },
];

const AnnouncementProgressList = ({ history }) => {
  const [loading, setLoading] = useState();
  const [reloadSource, setReloadSource] = useState(false);

  const terminate = async (id) => {
    try {
      setLoading(id);
      await terminateAnnouncement(id);
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_MSG,
        duration: 2,
      });
      setReloadSource({});
    } catch (err) {
      catchExceptionSRate(err, MESSAGES.DESC_ERROR_DELETE_MSG);
    } finally {
      setLoading();
    }
  };

  const [sortColumn, setSortColumn] = useState('-created_at');
  const columns = [
    {
      title: (
        <>
          Tipo
          <CustomTooltip
            title={
              <p>
                Convocatoria <br />
                A: Abierta
                <br />
                C: Cerrada
              </p>
            }
          />
        </>
      ),
      dataIndex: 'tipo_sigla',
      align: 'center',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('tipo_sigla');
        if (sortOrder === 'descend') setSortColumn('-tipo_sigla');
      },
    },
    {
      title: 'Estado',
      dataIndex: 'estado_lanzamiento',
      width: '5em',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('estado_lanzamiento');
        if (sortOrder === 'descend') setSortColumn('-estado_lanzamiento');
      },
    },
    {
      title: 'Proyecto',
      dataIndex: 'nombre_proyecto',
      width: '20em',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('nombre_proyecto');
        if (sortOrder === 'descend') setSortColumn('-nombre_proyecto');
      },
    },
    {
      title: 'Organización',
      dataIndex: 'organizacion_nombre',
      width: '20em',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('organizacion_nombre');
        if (sortOrder === 'descend') setSortColumn('-organizacion_nombre');
      },
    },
    {
      title: 'No. conv',
      dataIndex: 'numero',
      align: 'center',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('created_at');
        if (sortOrder === 'descend') setSortColumn('-created_at');
      },
    },
    {
      title: 'Nombre convocatoria',
      dataIndex: 'nombre',
      width: '20em',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('nombre');
        if (sortOrder === 'descend') setSortColumn('-nombre');
      },
    },
    {
      title: 'Fecha inicio',
      dataIndex: 'fecha_inicio',
      align: 'center',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('fecha_inicio');
        if (sortOrder === 'descend') setSortColumn('-fecha_inicio');
      },
    },
    {
      title: 'Fecha fin',
      dataIndex: 'fecha_fin',
      align: 'center',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('fecha_fin');
        if (sortOrder === 'descend') setSortColumn('-fecha_fin');
      },
    },
    {
      title: '# Cargo / Rol',
      dataIndex: 'num_cargos',
      align: 'center',
      width: '5em',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('num_cargos');
        if (sortOrder === 'descend') setSortColumn('-num_cargos');
      },
    },
    {
      title: 'Acciones',
      dataIndex: 'accion',
      align: 'center',
      fixed: 'right',
      width: 150,
      render: (_, record) => (
        <Space>
          <IconButton
            disabled={loading}
            title="Editar"
            bordered
            color="green"
            linkTo={`${INTERNAL_LINKS.ANNOUNCEMENT_FORM}/${record.id}`}
            icon={<EditFilled />}
          />
          <IconButton
            disabled={loading}
            title="Detalle"
            bordered
            color="bigaro"
            linkTo={`${INTERNAL_LINKS.ANNOUNCEMENT_DETAILS}/${record.id}`}
            icon={<TagsFilled />}
          />
          <Popconfirm
            title={MESSAGES.END_CONFIRM_MSG}
            okText="Si"
            cancelText="No"
            onConfirm={() => terminate(record.id)}
          >
            <IconButton
              title="Terminar"
              bordered
              color="red"
              icon={<CloseCircleFilled />}
              loading={loading === record.id}
              disabled={loading}
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const back = () => {
    history.push(INTERNAL_LINKS.ANNOUNCEMENT);
  };

  return (
    <Content>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        Convocatorias en curso
      </Title>
      <AjaxTable
        columns={columns}
        pageSize={10}
        tableTitle={'Listado de convocatorias en curso'}
        endpoint={filterAnnouncements}
        sortBy={sortColumn}
        reloadSource={reloadSource}
        searchInput
        exportCSV
      />
      <CustomButton
        type={'default'}
        className={'back-button'}
        htmlType="button"
        onClick={() => back()}
        text="Volver"
      />
    </Content>
  );
};

export default AnnouncementProgressList;
